export enum SessionFilesStatus {
  SESSION_FILES_UPLOADED = 'session-files-uploaded',
  PRESESSION_UPLODED = 'presession-uploaded'
}
